import Vue from 'vue'
import _ from 'lodash'

export function toast(text, opts) {
    opts = _.assign({
        theme: 'toasted-primary',
        duration: 4000,
        position: 'top-center',
    }, opts);
    return Vue.toasted.show(text, opts);
}



// WEBPACK FOOTER //
// ./src/utils/interactions.js